import { render, staticRenderFns } from "./Billboard.vue?vue&type=template&id=befec63e&scoped=true"
import script from "./Billboard.vue?vue&type=script&lang=js"
export * from "./Billboard.vue?vue&type=script&lang=js"
import style0 from "./Billboard.vue?vue&type=style&index=0&id=befec63e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befec63e",
  null
  
)

export default component.exports